<template>
 	<b-container fluid class="sous_block">
    <b-row class="mb-1" align-h="between" align-v="center">
      <b-col style="max-width: 150px; text-align: left;">
        <label class="m-0" for="color_input" >Color display:</label>
        <b-form-select id='color_input' v-model="color_selected" :options="color_options" size="sm" class="mb-1 w-20"></b-form-select>
      </b-col>
      <b-col>
        <i style="float: right;" class="fa-2x fas fa-question-circle" v-b-tooltip.hover.top title="Click on an amino acid below to target the corresponding HMM Logo position above"></i>
      </b-col>
    </b-row >
            
    <b-row :style="displaydiv"  id="align_area" class="px-2 skylign">
      <div v-for="(seqAlignTest, index) in seqAlignTest" align-v="end" style="border: 1px solid #BDBDBD; background-color: #FAFAFA;" class="row w-100 mb-3 mx-1 pt-2" v-bind:id="'container_idx'+index">
        <b-row class="w-100">
          <b-col cols="6" class="py-1" style="text-align: left;">
            <span><h5 class="pl-2">{{domSelected[index].pfid}}</h5></span>
          </b-col>
          <b-col cols="6" style="text-align: right;" class="mb-2">
            <b-button style="" class="button_hide_show btn-theme" :pressed.sync="buttons[index]" >
              <div v-if="buttons[index]">Hide</div><div v-else >Show</div></b-button>
          </b-col>
        </b-row>
        <b-row class="w-100 px-2" v-html="seqAlignTest"></b-row>
      </div>
    </b-row>
  </b-container>
</template>

<script>

export default {
 		props: {
 			domSelected: [String,Array],
 			entryId: String,
 			seqAlignTest: Array,
      ck:Number
 		},
    data(){
      return {
        showdiv:true,
        Collapse: true,
        borderless: true,
        small: true,
        color_options:[{ value: 'skylign', text: 'Skylign' },{ value: 'rasmol', text: 'Rasmol'},{ value: 'shapely', text: 'Rasmol Shapely' },{ value: 'clustalX', text: 'ClustalX'}],
        color_selected:'skylign',
        buttons: []
        // fields1: [{key:'entry_name',label:'Entry Name',stickyColumn: true,class:'p-0'},{key: 'pos', label:'Start/End',stickyColumn:true,class:'p-0'}],
        // fields2: [{key: 'html' ,label:'Sequence',class:'text-nowrap p-0'}]
        }
      },
    created() {
      for (var i = 0; i < this.seqAlignTest.length; i++) {
        this.buttons[i] = true
      }
    },
 		mounted() {
      		console.log('ALIGNEMENT VIEWER Component mounted.')
          for (var i = 0; i < this.buttons.length; i++) {
            $("#tab_1_"+i).parent().css('overflow-y','hidden');
            this.move_both_scroll(i)
            this.test(i,this.ck)
          }
          this.zoom_on_interest_pos()
        },
	    computed:{
            displaydiv(){
                return {
                    display : this.showdiv ? "block" : "none"
                }
            }
        },
	    watch: {
        color_selected: function(newVal, oldVal){
          $("#align_area").removeClass(oldVal).addClass(newVal)
          $("#fv1").removeClass(oldVal).addClass(newVal)
        }
      },
    	methods:{
        test(idx,ck){
          $('#tab_2_'+idx+" .letter" ).hover(function() {
            var a = $( this ).attr('value');
            $(".pos_logo_"+a).toggleClass('letter_hover')
          }).click(function(){
            var a = $( this ).attr('value');
            var id = '#logo'+ck+'_'+idx;
            $(id+' .logo_position').val(a).change();
          });
        },
        pos_prot_to_pos_logo(nb,idx){
            var id = '#logo'+this.ck+'_'+idx
            $(id+' .logo_position').val(nb).change();
        },
        move_both_scroll(i){
          $("#tab_2_"+i).parent().scroll(function () { 
            $("#tab_1_"+i).parent().scrollTop($("#tab_2_"+i).parent().scrollTop());
            // $("#div1").scrollLeft($("#div2").scrollLeft());
          });
        },
        zoom_on_interest_pos(){
          for (var i = 0; i < this.domSelected.length; i++) {
            if (this.domSelected[i].pos_in_logo) {
              const nb = this.domSelected[i].pos_in_logo
              var e = document.querySelectorAll('#container_idx'+i+" span.pos_logo_"+nb+".input_mut")[0]
              var y = e.offsetParent.offsetTop
              var x = e.offsetLeft

              var input1 = document.getElementById('container_idx'+i).getElementsByClassName("pos_logo_"+nb)
              for(let i = 0;i < input1.length; i++){
                    input1[i].style.backgroundColor = "rgba(114, 210, 234, 0.5)";
              }
              
            }else{
              var e = document.querySelectorAll('#container_idx'+i+" span.input_mut:not(.letter)")
              e = e[Math.ceil((e.length-1)/2)]
              var y = e.offsetParent.offsetTop
              var x = e.offsetLeft
            }

            var el = document.getElementById('overflow_2_'+i)
            el.scrollLeft = x-((el.offsetWidth)/2) < 0 ? 0:x-((el.offsetWidth)/2);
            el.scrollTop = y-((el.offsetHeight-18)/2) < 0 ? 0:y-((el.offsetHeight-18)/2) ;
            
          }
        }
      } 
	}


</script>
